import { SmartfireComponent } from "@smartfire/gutenberg-react";
import * as React from "react";
import "./style.scss";
import DevisButton from "../devis-button/block.js";

export default class MosaicPlaceholder extends SmartfireComponent {
  render() {
    return (
      <div className="mosaic-placeholder">
        <h2>Contactez-nous !</h2>
        <div className="phone">
          <a href={"tel:" + this.props.phone}>{this.props.phone}</a>
        </div>
        <div className="button">
          <DevisButton
            buttonTitle="Vous avez besoin d'un devis ?"
            buttonText="Les équipes CAPSA Container restent à votre écoute !"
            event="devis"
            color="white"
          />
        </div>
      </div>
    );
  }
}
